import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import { ReturnIcon, useKeyboardNavigation } from '@atlassian/search-dialog';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { getTrigger, isNewTab, onAdvancedSearchSelected, useAnalytics } from '../../common/analytics';
import { Trigger } from '../../common/analytics/events';
import { AdvancedSearchContent, AdvancedSearchLink, CenteredAdvancedSearchGroup } from '../../common/advanced-search-link';
import { useProductContext } from '../product-router';
import { useQuery } from '../query-context';
import { AdvancedSearchLinkWrapper } from './advanced-search.styled';
var onKeyDown = function onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent) {
  if (e.key === 'Enter' && !e.shiftKey) {
    var _target$firstElementC, _target$firstElementC2;
    e.preventDefault();
    fireAnalyticsEvent(onAdvancedSearchSelected({
      trigger: Trigger.RETURN,
      actionSubjectId: actionSubjectId,
      isLoading: false,
      newTab: false
    }));
    // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
    (_target$firstElementC = target.firstElementChild) === null || _target$firstElementC === void 0 || (_target$firstElementC2 = _target$firstElementC.click) === null || _target$firstElementC2 === void 0 || _target$firstElementC2.call(_target$firstElementC);
  }
};
export var AdvancedSearch = function AdvancedSearch(_ref) {
  var _getActiveProduct;
  var advancedSearchMessage = _ref.advancedSearchMessage,
    advancedSearchUrl = _ref.advancedSearchUrl,
    linkComponent = _ref.linkComponent;
  var _useQuery = useQuery(),
    isLoading = _useQuery.isLoading;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var productName = (_getActiveProduct = getActiveProduct()) === null || _getActiveProduct === void 0 ? void 0 : _getActiveProduct.title;
  var actionSubjectId = "".concat(productName, "AdvancedSearchLink");
  var onAdvancedSearchClicked = useCallback(function (e) {
    fireAnalyticsEvent(onAdvancedSearchSelected({
      trigger: getTrigger(e),
      actionSubjectId: actionSubjectId,
      isLoading: isLoading,
      newTab: isNewTab(e)
    }));
  }, [fireAnalyticsEvent, actionSubjectId, isLoading]);
  var _useKeyboardNavigatio = useKeyboardNavigation({
      onKeydownCallback: useCallback(function (e, target) {
        return onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent);
      }, [actionSubjectId, fireAnalyticsEvent])
    }),
    _useKeyboardNavigatio2 = _slicedToArray(_useKeyboardNavigatio, 2),
    isKeyboardHighlighted = _useKeyboardNavigatio2[0],
    ref = _useKeyboardNavigatio2[1];
  if (!advancedSearchUrl || !advancedSearchMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AdvancedSearchLinkWrapper, {
    ref: ref,
    onClick: onAdvancedSearchClicked,
    role: "none"
  }, /*#__PURE__*/React.createElement(AdvancedSearchLink, {
    href: advancedSearchUrl,
    isKeyboardHighlighted: isKeyboardHighlighted,
    linkComponent: linkComponent
  }, /*#__PURE__*/React.createElement(CenteredAdvancedSearchGroup, null, /*#__PURE__*/React.createElement(SearchIcon, {
    size: "small",
    label: advancedSearchMessage
  }), /*#__PURE__*/React.createElement(AdvancedSearchContent, null, advancedSearchMessage)), isKeyboardHighlighted && /*#__PURE__*/React.createElement(ReturnIcon, {
    inverted: isKeyboardHighlighted
  })));
};